import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import HorizontalDivider from "src/components/HorizontalDivider/HorizontalDivider";
import VerticalDivider from "src/components/VerticalDivider/VerticalDivider";
import { getTextValueById, isRtl } from "src/utils/helpers";

const InvoiceCompanyDetails = () => {
  const { t } = useTranslation(["common", "registration", "invoice"]);
  const emirateOptions = useSelector(
    (state: any) => state.lookup?.emiratesOptions
  );
  const citiesOptions = useSelector((state: any) => state.lookup?.citiesOptions);
  const {
    name,
    tradeLicenseNumber,
    civilDefenseLicense,
    emirate,
    city,
    contactPersonName,
    phoneNumber,
    officeAddress,
    email,
    companyIDNumber
  } = useSelector((state: any) => state.bMCProfile?.BMCData);
  
  const language = useSelector((state: any) => state.lookup.language);

  return (
    <section className="invoice-body mt-1" style={{ direction: isRtl(language) ? "rtl" : "ltr" }}>
      <div className="invoice-body__title py-1 cell-header" style={{ textAlign: isRtl(language) ? "right" : "left" }}>
        {t("invoiceDetails.companyDetails")}
      </div>
      <div className="invoice-header__details__info d-flex flex-column">
        <div className="invoice-header__details__info__row d-flex justify-content-between">
          <div className="invoice-header__details__info__row__item d-flex align-items-start flex-column w-25">
            <h6>{t("invoiceDetails.companyName")}</h6>
            <span>{name}</span>
          </div>
          <VerticalDivider />
          <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-between  flex-column w-25">
            <h6>{t("invoiceDetails.bmcId")}</h6>
            <span>{companyIDNumber}</span>
          </div>
          <VerticalDivider />
          <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-between  flex-column w-25">
            <h6>{t("invoiceDetails.tradeLicenseNo")}</h6>
            <span>{tradeLicenseNumber}</span>
          </div>
          <VerticalDivider />
          <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-between  flex-column w-25">
            <h6>{t("invoiceDetails.cdLicenseNo")}</h6>
            <span>{civilDefenseLicense}</span>
          </div>
        </div>
        <HorizontalDivider />
        <div className="invoice-header__details__info__row d-flex justify-content-between">
          <div className="invoice-header__details__info__row__item d-flex align-items-start flex-column w-25">
            <h6>{t("city")}</h6>
            <span>{getTextValueById(city, citiesOptions, "cityId")}</span>
          </div>
          <VerticalDivider />
          <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-between  flex-column w-25">
            <h6>{t("emirate")}</h6>
            <span>
              {getTextValueById(emirate, emirateOptions, "emirateId")}
            </span>
          </div>
          <VerticalDivider />
          <div className="invoice-header__details__info__row__item multiple d-flex align-items-start justify-content-between  flex-column w-50">
            <h6>{t("address")}</h6>
            <span>{officeAddress}</span>
          </div>
        </div>

        <HorizontalDivider />
        <div className="invoice-header__details__info__row d-flex justify-content-between">
          <div className="invoice-header__details__info__row__item d-flex align-items-start flex-column w-25">
            <h6>{t("contactPersonName")}</h6>
            <span>{contactPersonName}</span>
          </div>
          <VerticalDivider />
          <div className="invoice-header__details__info__row__item d-flex align-items-start justify-content-between  flex-column w-25">
            <h6>{t("phone")}</h6>
            <span>{phoneNumber}</span>
          </div>
          <VerticalDivider />
          <div className="invoice-header__details__info__row__item multiple d-flex align-items-start justify-content-between   flex-column w-50">
            <h6>{t("email")}</h6>
            <span>{email}</span>
          </div>
        </div>
      </div>
      <HorizontalDivider />
    </section>
  );
};

export default InvoiceCompanyDetails;
